import {  MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { StyledFormControl } from '../../styles/common/UIComponents';
import useCategoriesByLoyalty from '../../hooks/useCategoriesByLoyalty';

const CategoryFilter = (props) => {

  const location = useLocation();
  const navigate = useNavigate();

  // Obter o parâmetro 'category' da URL para definir o valor inicial
  const initialCategory = new URLSearchParams(location.search).get('category') || '';

  const [selectedCategory, setSelectedCategory] = React.useState(initialCategory);

  const { categories, loading, error } = useCategoriesByLoyalty(props.slug);


  const nameToSlug = (str) => {
    return str
      .normalize('NFD') // separa acentos
      .replace(/[\u0300-\u036f]/g, '') // remove acentos
      .toLowerCase() // minúsculo
      .trim() // remove espaços extras
      .replace(/\s+/g, '-') // espaços -> hífen
      .replace(/[^\w-]/g, ''); // remove caracteres especiais
  };


  const handleChange = (event) => {
    const selectedSlug = event.target.value;
    setSelectedCategory(selectedSlug);

    // Atualizar os query params na URL
    const searchParams = new URLSearchParams(location.search);
    if (selectedSlug) {
      searchParams.set('category', selectedSlug); // Adiciona o slug como parâmetro
    } else {
      searchParams.delete('category'); // Remove o parâmetro se "Todas as Categorias" for selecionada
    }
    searchParams.delete('page'); // Volta para a primeira página ao trocar de categoria
    navigate({ search: searchParams.toString() });
  };

  return (
    <StyledFormControl>
      <Select
        value={selectedCategory}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{

          [theme => theme.breakpoints.up('md')]: {
            padding: '0 40px',
          },
        }}
      >
        <MenuItem value="">
          <em>Todas as Categorias</em>
        </MenuItem>
        {categories.map((slug) => (
          <MenuItem key={slug} value={nameToSlug(slug)}>
            {slug}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default CategoryFilter;
